// Simple GA4 analytics helpers for SPA page views and events
// Uses window.gtag if available; safely no-ops otherwise.

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

const hasGtag = () => typeof window !== 'undefined' && typeof window.gtag === 'function';

export const trackPageView = (pagePath: string, pageTitle?: string) => {
  if (hasGtag()) {
    window.gtag!('event', 'page_view', {
      page_title: pageTitle || document.title,
      page_location: typeof window !== 'undefined' ? window.location.href : undefined,
      page_path: pagePath,
    });
  }
};

export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  if (hasGtag()) {
    window.gtag!('event', eventName, params || {});
  }
};

export default { trackPageView, trackEvent };